if (!customElements.get('fb-product')) {
  customElements.define('fb-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      const select = this.querySelector('[data-variant]');
      const updateConditionalFields = () => {
        const title = select?.options[select.selectedIndex]?.dataset.title || '';
        this.querySelectorAll('[data-variant-condition]').forEach(group => {
          const active = title.includes(group.dataset.variantCondition);
          group.hidden = !active;
          group.querySelectorAll('input, select, textarea').forEach(input => {
            input.disabled = !active;
            input.required = active && input.dataset.required === 'true';
          });
        });
      };
      updateConditionalFields();
      this.querySelectorAll('[data-upload]').forEach(input => {
        input.addEventListener('change', () => {
          const file = input.files[0];
          input.setCustomValidity(file && file.size > 20 * 1024 * 1024 ? (input.dataset.sizeError || 'Please choose a file smaller than 20 MB.') : '');
          input.reportValidity();
        });
      });
      const showMedia = id => {
        if (!id || !this.querySelector(`[data-media="${id}"]`)) return;
        this.querySelectorAll('.fb-product-slide').forEach(slide => {
          slide.hidden = slide.dataset.media !== id;
          if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause());
        });
        this.querySelectorAll('[data-thumbnail]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.thumbnail === id)));
      };
      this.querySelectorAll('[data-thumbnail]').forEach(button => button.addEventListener('click', () => showMedia(button.dataset.thumbnail)));
      select?.addEventListener('change', () => {
        updateConditionalFields();
        const option = select.options[select.selectedIndex];
        this.querySelector('[data-price]').textContent = option.dataset.price;
        const compare = this.querySelector('[data-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
        const selected = this.querySelector('[data-selected]');
        if (selected) selected.textContent = `for ${option.dataset.title}`;
        const add = this.querySelector('[data-add]');
        add.disabled = option.dataset.available !== 'true';
        add.textContent = add.disabled ? 'Sold out' : `Add to bag — ${option.dataset.price}`;
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
        showMedia(option.dataset.media);
      });
      this.querySelectorAll('[data-print-date]').forEach(input => {
        input.addEventListener('input', () => input.setCustomValidity(''));
        const validate = () => {
          if (!input.value && !input.required) return input.setCustomValidity('');
          const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(input.value.trim());
          const date = match && new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]));
          const valid = match && date.getFullYear() === Number(match[3]) && date.getMonth() === Number(match[2]) - 1 && date.getDate() === Number(match[1]);
          input.setCustomValidity(valid ? '' : 'Please enter a valid date in DD/MM/YYYY format.');
        };
        input.addEventListener('change', validate);
        this.querySelector('form').addEventListener('submit', event => {
          validate();
          if (!input.checkValidity()) { event.preventDefault(); input.reportValidity(); }
        });
      });
      const form = this.querySelector('form');
      form.addEventListener('submit', async event => {
        if (event.defaultPrevented) return;
        if ([...form.querySelectorAll('[data-upload]')].some(input => !input.disabled && input.files.length)) {
          if (!form.reportValidity()) event.preventDefault();
          return;
        }
        event.preventDefault();
        if (!form.reportValidity() || this.adding) return;
        this.adding = true;
        const button = this.querySelector('[data-add]');
        const error = this.querySelector('[data-cart-error]');
        const label = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding to bag…';
        error.hidden = true;
        try {
          const response = await fetch(this.dataset.addUrl, {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Please try again.');
          window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          error.textContent = /cannot find variant/i.test(failure.message) ? 'This product is not available to purchase yet.' : `We couldn’t add this to your bag. ${failure.message}`;
          error.hidden = false;
          button.disabled = false;
          button.textContent = label;
          this.adding = false;
        }
      });
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const activate = tab => {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          this.querySelector(`#${item.getAttribute('aria-controls')}`).hidden = !active;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(tabs[next]); tabs[next].focus(); }
        });
      });
      const dialog = this.querySelector('dialog');
      this.querySelectorAll('[data-zoom]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        const image = dialog.querySelector('img');
        image.src = link.href;
        image.alt = link.querySelector('img').alt;
        dialog.showModal();
      }));
      dialog.querySelector('[data-close-zoom]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    }
  });
}
